import { Component } from 'react'

import ErrorTracker from 'common/helpers/errorTracker'

const TRACKER_EVENT_TYPE = ErrorTracker.getEvents()

ErrorTracker.init()
export default class ErrorBoundary extends Component {
  componentDidCatch(error: unknown) {
    ErrorTracker.send(TRACKER_EVENT_TYPE.ERROR, error)
  }

  render() {
    return this.props.children
  }
}
